<template>
  <div style="background: #eee;">
    <el-row>
      <el-col v-for="(item,index) in list" :key="index" :span="6">
        <el-card :body-style="{ padding: '0px' }">
          <div style="padding: 10px;">
            <img :src="item.icon" width="20" style="vertical-align: bottom">
            <span
              style="font-size:14px;color:#333;padding-left:8px;font-width: bold;"
            >{{ item.accountBank }}</span>
            <div class="cardStyle" style>
              <span v-if="item.cardType === '00'">借记卡</span>
              <span v-else-if="item.cardType === '01'">贷记卡</span>
              <span v-else-if="item.cardType === '02'">准贷记卡</span>
              <span v-else-if="item.cardType === '03'">预付费卡</span>
              <span v-else>综合</span>
            </div>
          </div>
          <div style="text-align: center;padding-top:10px;">
            <span style="font-size:14px;">**** **** **** {{ trans(item.bankCardNoMask) }}</span>
          </div>
          <div style="padding-top:10px;padding-bottom:15px;overflow:hidden;padding-left:10px;">
            <span class="bor-after" style="position:relative;">
              <i class="iposition" style="left:2px;">快</i>
            </span>
            <span class="bor-before" style="position:relative;">
              <i class="iposition" style="left:17px;">捷</i>
            </span>
            <!-- <el-button type="text" class="button" @click="skip(item)">管理</el-button> -->
            <el-button type="text" class="button">&nbsp;</el-button>
          </div>
        </el-card>
      </el-col>
      <el-card :body-style="{ padding: '0px' }">
        <div class="bankAddbox" @click="add">
          <div class="pt22">
            <i class="add-icon">+</i>
            <span class="add-font">添加银行卡</span>
          </div>
        </div>
      </el-card>
    </el-row>
    <el-dialog :visible.sync="renzhengVisible" width="35%">
      <div class="rztext">
        <div>
          <img src="../../assets/images/rzpic.png" class="rzimg">
        </div>
        <div class="rztext_tit">实名提醒</div>
        <div>您还没有进行实名认证，认证后即可绑定银行卡</div>
      </div>
      <div slot="footer" class="dialog-footer" style="width:40%;margin: 0 auto">
        <el-button type="primary" @click="gotoAuth">去认证</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { cardT } from '@/api/bankcard/bankcard'
import { getCusList, getCompList } from '@/api/bankcard/bankcard'
import store from '@/store'
import Session from '@/utils/session'
// import { hello } from '@/api/demo/hello'
export default {
  name: 'Index',
  data() {
    return {
      cardT,
      currentDate: new Date(),
      list: [],
      customerType: Session.getItem('customerType'),
      renzhengVisible: false
    }
  },
  watch: {
    '$route': function(to, from) {
      this.getList()
    }
  },
  created() {
    this.getList()
  },
  methods: {
    skip(item) {
      this.$router.push({
        name: 'detail',
        params: item
      })
    },
    gotoAuth() {
      this.renzhengVisible = false
      if (this.customerType === '6') {
        this.$router.push({
          name: 'personalAuth'
        })
      } else {
        this.$router.push({
          name: 'companyAuth'
        })
      }
    },
    add() {
      if (Session.getItem('authFlag') !== '00') {
        if (this.customerType === '6') {
          this.$router.push({
            name: 'add'
          })
        } else {
          this.$router.push({
            name: 'addBus'
          })
        }
      } else {
        this.renzhengVisible = true
      }
    },
    // 转为带***的卡号
    trans(val) {
      console.log(val)
      val = val.substring(val.length - 4)
      return val
    },
    getList() {
      const param = {
        customerId: store.getters.customerId,
        page: 1,
        size: 10
      }
      if (Session.getItem('customerType') === '6') {
        getCusList(param).then(response => {
          this.list = response.data.list
        })
      } else {
        getCompList(param).then(response => {
          this.list = response.data.list
        })
      }
    }
  }
}
</script>

<style >
.time {
  font-size: 13px;
  color: #999;
}

.bottom {
  margin-top: 13px;
  line-height: 12px;
}

.button {
  float: right;
}
.image {
  width: 100%;
  display: block;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both;
}
</style>
<style scoped>
.iposition {
  position: absolute;
  z-index: 2;
  color: #fff;
  font-size: 12px;
  top: 10px;
}
.bor-after:before,
.bor-before:before {
  content: "";
  position: absolute;
  width: 18px;
  display: inline-block;
  text-align: center;
  background: #8dbd57;
  height: 20px;
  border-radius: 50%;
  left: 0px;
  top: 10px;
  z-index: 1;
}
.bor-before:before {
  left: 15px;
}
.cardStyle {
  float: right;
  background: #e50007;
}
.cardStyle span {
  font-size: 12px;
  color: #fff;
  padding: 6px;
  display: inline-block;
}
.bankAddbox {
  cursor: pointer;
  padding: 10px;
  height: 103px;
  background: #fff;
  text-align: center;
}

.add-icon {
  width: 35px;
  height: 35px;
  cursor: pointer;
  border-radius: 50%;
  line-height: 35px;
  color: #e50007;
  display: inline-block;
  border: 1px solid red;
  text-align: center;
  font-style: normal;
  font-size: 16px;
}
.pt22 {
  padding-top: 22px;
}
.add-font {
  font-size: 15px;
  display: block;
  cursor: pointer;
  color: #e50007;
  padding-top: 5px;
}
</style>
<style scoped>
.el-button {
  width: 100%;
}
.rztext {
  text-align: center;
  font-size: 14px;
  color: #666666;
}
.rztext_tit {
  font-size: 20px;
  color: #333333;
  margin: 21px 0 12px;
}
.rzimg {
  width: 84px;
  height: 84px;
}
</style>
